import { RedriveApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";

export const useExecuteRedrive = () => {
  const executeRedrive = async (
    file: File,
    selectedStage: string,
    setSelectedExecutionId: (id: string | null) => void,
    setError: (error: string) => void
  ) => {
    try {
      const fileContent = await file.text();
      const redriveApi = RedriveApiFactory();
      const response = await redriveApi.postRedriveInfo(selectedStage, {
        file_data: fileContent,
      });

      // Navigate to the orders view for this execution
      if (response.data && response.data.executionId) {
        setSelectedExecutionId(response.data.executionId);
        // Update URL to include the execution ID
        window.history.pushState(
          {},
          '',
          `?stage=${encodeURIComponent(selectedStage)}&executionId=${encodeURIComponent(response.data.executionId)}`
        );
      } else {
        // Fallback to reload if no execution ID
        window.location.reload();
      }
    } catch (err) {
      setError(`Failed to execute redrive: ${err instanceof Error ? err.message : String(err)}`);
    }
  };

  const executeSingleRedrive = async (orderId: string, stage: string) => {
    const redriveApi = RedriveApiFactory();
    return await redriveApi.postRedriveInfo(stage, {
      file_data: orderId,
    });
  };

  return { executeRedrive, executeSingleRedrive };
};
